import React from 'react';
import './AppIcon.css';

const PATHS = {
  orders: (
    <>
      <path d="M8 6h13" />
      <path d="M8 12h13" />
      <path d="M8 18h13" />
      <path d="M3 6h.01" />
      <path d="M3 12h.01" />
      <path d="M3 18h.01" />
    </>
  ),
  create: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 8v8" />
      <path d="M8 12h8" />
    </>
  ),
  store: (
    <>
      <path d="M3 9l1.5-4.5A2 2 0 0 1 6.4 3h11.2a2 2 0 0 1 1.9 1.5L21 9" />
      <path d="M3 9h18v11a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9z" />
      <path d="M9 21V12h6v9" />
    </>
  ),
  pos: (
    <>
      <rect x="3" y="4" width="18" height="14" rx="2" />
      <path d="M7 20h10" />
      <path d="M8 9h8" />
      <path d="M8 13h5" />
    </>
  ),
  owner: (
    <>
      <path d="M3 21h18" />
      <path d="M5 21V8l7-4 7 4v13" />
      <path d="M9 21v-6h6v6" />
    </>
  ),
  accountant: (
    <>
      <rect x="4" y="3" width="16" height="18" rx="2" />
      <path d="M8 8h8" />
      <path d="M8 12h8" />
      <path d="M8 16h5" />
    </>
  ),
  analytics: (
    <>
      <path d="M4 19V5" />
      <path d="M4 19h16" />
      <path d="M8 16v-5" />
      <path d="M12 16V8" />
      <path d="M16 16v-8" />
    </>
  ),
  users: (
    <>
      <circle cx="9" cy="8" r="3" />
      <path d="M3 20c0-3.3 2.7-6 6-6" />
      <circle cx="17" cy="9" r="2.5" />
      <path d="M21 20c0-2.8-2.2-5-5-5" />
    </>
  ),
  agents: (
    <>
      <path d="M3 17h2l1.5-5.5A2 2 0 0 1 8.4 10H14" />
      <path d="M14 10h3l3 4v3h-2" />
      <circle cx="7.5" cy="17.5" r="1.5" />
      <circle cx="17.5" cy="17.5" r="1.5" />
      <path d="M5 10V7h6" />
    </>
  ),
  desserts: (
    <>
      <path d="M6 11c0-3.3 2.7-6 6-6s6 2.7 6 6" />
      <path d="M5 11h14v2a7 7 0 0 1-14 0v-2z" />
      <path d="M8 21h8" />
    </>
  ),
  cupcakes: (
    <>
      <path d="M8 11c0-2.2 1.8-4 4-4s4 1.8 4 4" />
      <path d="M7 11h10l-1.2 7.2A2 2 0 0 1 13.8 20h-3.6a2 2 0 0 1-2-1.8L7 11z" />
      <path d="M12 4v3" />
    </>
  ),
  plants: (
    <>
      <path d="M12 21V11" />
      <path d="M12 11c-3-1-5-3.5-5-7 4 0 5 3 5 7z" />
      <path d="M12 11c3-1 5-3.5 5-7-4 0-5 3-5 7z" />
      <path d="M8 21h8" />
    </>
  ),
  flavours: (
    <>
      <path d="M12 3c2.5 3 4 5.5 4 8a4 4 0 0 1-8 0c0-2.5 1.5-5 4-8z" />
      <path d="M9 21h6" />
      <path d="M10 17h4" />
    </>
  ),
  catering: (
    <>
      <path d="M4 11h16" />
      <path d="M5 11c0 4 2.5 7 7 7s7-3 7-7" />
      <path d="M8 21h8" />
      <path d="M12 4v3" />
    </>
  ),
  planner: (
    <>
      <rect x="4" y="4" width="16" height="16" rx="2" />
      <path d="M4 10h16" />
      <path d="M10 4v16" />
    </>
  ),
  home: (
    <>
      <path d="M3 11.5 12 4l9 7.5" />
      <path d="M6 10.5V20h12v-9.5" />
    </>
  ),
  currency: (
    <>
      <path d="M6 8h9a3 3 0 0 1 0 6H9" />
      <path d="M9 14h6a3 3 0 0 1 0 6H6" />
      <path d="M9 4v16" />
    </>
  ),
  catalog: (
    <>
      <path d="M5 4h10a2 2 0 0 1 2 2v14l-4-2-4 2V6a2 2 0 0 0-2-2H5z" />
      <path d="M9 8h5" />
      <path d="M9 12h5" />
    </>
  ),
  eye: (
    <>
      <path d="M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6S2 12 2 12z" />
      <circle cx="12" cy="12" r="2.5" />
    </>
  ),
  eyeOff: (
    <>
      <path d="M3 3l18 18" />
      <path d="M10.6 10.6A2.5 2.5 0 0 0 13.4 13.4" />
      <path d="M9.9 5.2A10.4 10.4 0 0 1 12 5c6.5 0 10 7 10 7a17.5 17.5 0 0 1-3.1 3.9" />
      <path d="M6.1 6.1A17.3 17.3 0 0 0 2 12s3.5 6 10 6c1.4 0 2.7-.3 3.9-.8" />
    </>
  ),
  chevron: (
    <>
      <path d="M9 6l6 6-6 6" />
    </>
  ),
  print: (
    <>
      <path d="M6 9V4h12v5" />
      <path d="M6 17H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-2" />
      <rect x="6" y="14" width="12" height="7" rx="1" />
    </>
  ),
  share: (
    <>
      <circle cx="18" cy="5" r="2.5" />
      <circle cx="6" cy="12" r="2.5" />
      <circle cx="18" cy="19" r="2.5" />
      <path d="M8.3 13.2l7.4 4.1" />
      <path d="M15.7 6.7l-7.4 4.1" />
    </>
  ),
  chat: (
    <>
      <path d="M4 5h16v11H8l-4 3V5z" />
    </>
  ),
  edit: (
    <>
      <path d="M4 20h4l11-11-4-4L4 16v4z" />
      <path d="M13 7l4 4" />
    </>
  ),
  back: (
    <>
      <path d="M15 6l-6 6 6 6" />
    </>
  ),
  delivery: (
    <>
      <path d="M3 7h11v10H3z" />
      <path d="M14 10h4l3 3v4h-7V10z" />
      <circle cx="7" cy="18" r="1.5" />
      <circle cx="17" cy="18" r="1.5" />
    </>
  )
};

/**
 * Monochrome line icons — black/gold friendly, no emoji color noise.
 */
const AppIcon = ({ name, size = 20, className = '', title }) => {
  const paths = PATHS[name] || PATHS.orders;
  return (
    <svg
      className={`app-icon ${className}`.trim()}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden={title ? undefined : true}
      role={title ? 'img' : undefined}
    >
      {title ? <title>{title}</title> : null}
      {paths}
    </svg>
  );
};

export default AppIcon;
